module.exports = __webpack_public_path__ + "static/media/swish-demo-100.e01a5341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swish-demo-100.png
// module id = 417
// module chunks = 0